<script setup>
//region Imports
import { ref, onMounted, reactive } from 'vue'
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))

const clickToCancel = () => {
  if (!confirm('Are you sure?')) {
    return
  }

  location.replace('#/claim/shipping')
}

const saveShippingAddress = e => {
  e.preventDefault()
  shippingAddress.value = `${line1.value}, ${line2.value}, ${line3.value}`
  localStorage.setItem('tc-claim-data', JSON.stringify(Object.assign(data, {
    shippingAddress: shippingAddress.value,
  })))
  location.replace('#/claim/shipping')
}

const breakUpAddress = () => {
  const address = data.shippingAddress.split(', ')
  line1.value = address[0]
  line2.value = address[1]
  line3.value = address.filter((item, index) => index > 1).join(', ')
}
//endregion
//region Variables
const data = reactive(readData() ?? {})
const orderNumber = ref(data?.orderNumber)
const shippingAddress = ref(data?.shippingAddress)
const line1 = ref('')
const line2 = ref('')
const line3 = ref('')
const phone = ref(data?.shippingPhone)

//endregion
//region Lifecycle
onMounted(() => {
  if (!orderNumber.value) {
    location.replace('/')
  }

  breakUpAddress()
})
//endregion
</script>

<template>

<!--
<figure class="w-full h-[305px] overflow-hidden bg-no-repeat bg-right bg-cover"
          style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);">&nbsp;</figure>
-->

  <main class="px-[20px] my-[30px] lg:px-[40px] lg:max-w-[420px] lg:mx-auto">

    <div class="max-w-6xl mx-auto flex flex-row items-center mb-[38px]">
      <button type="button" @click="clickToCancel">
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
          <path d="M8 7L2 13L8 19" stroke="black" stroke-width="1.5"/>
        </svg>
      </button>
      <h1 class="font-bold text-tc-subtitle font-minionpro tracking-wider text-tc-black" v-text="`Edit Address`"></h1>
    </div>

    <form method="post" @submit="saveShippingAddress">

      <div class="grid grid-cols-1 gap-[12px]">
        <input type="text" v-model="line1" class="text-black font-avenir font-normal tracking-wide text-tc-xl w-full border-0 border-b border-tc-creme"/>
        <input type="text" v-model="line2" class="text-black font-avenir font-normal tracking-wide text-tc-xl w-full border-0 border-b border-tc-creme"/>
        <input type="text" v-model="line3" class="text-black font-avenir font-normal tracking-wide text-tc-xl w-full border-0 border-b border-tc-creme"/>
        <input type="text" v-model="phone" class="text-black font-avenir font-normal tracking-wide text-tc-xl w-full border-0 border-b border-tc-creme"/>
      </div>

      <div class="my-[30px] flex flex-row justify-between">
        <button
            type="button"
            @click="clickToCancel"
            class="text-black text-center font-avenir text-tc-xl font-normal tracking-wider py-2.5 px-8 border-b border-tc-creme"
        >Cancel
        </button>
        <button
            type="submit"
            class="text-black text-center font-avenir text-tc-xl font-normal tracking-wider py-2.5 px-8 border border-tc-creme"
        >Next
        </button>
      </div>

    </form>

  </main>

</template>

<style scoped>
</style>